module.exports = __webpack_public_path__ + "img/xsyficon01.png";